import Header from './Header'
import Sidebar from './Sidebar'

export default {
  Header,
  Sidebar
}
